import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ProductionState } from '../../models/production.model';

export const getProductionState = createFeatureSelector<ProductionState>('production-shared');

export const getProductionList = createSelector(
  getProductionState,
  (state: ProductionState) => state?.productionList,
);

export const getSelectedProduction = createSelector(
  getProductionState,
  (state: ProductionState) => state?.selectedProduction,
);
